import {action, observable} from "mobx";

export const FlashMessageType = {
    SUCCESS: "success",
    ERROR: "error",
};

export class FlashMessage {
    constructor(options) {
        this.type = options.type;
        this.title = options.title;
        this.message = options.message;
        this.buttonLabel = options.buttonLabel;
        this.buttonCancel = options.buttonCancel;
        this.visibility = options.visibility;
        this.link = options.link;
        this.animationType = options.animationType;
    }
}

class ConfigStore {
    @observable menuOpened = false;
    @observable animationType = 'left';
    @observable searchStudent = '';
    @observable flashMessage = new FlashMessage({
        type: FlashMessageType.SUCCESS,
        title: "Sucesso!",
        message: "Operação efetuada com Sucesso",
        buttonLabel: "OK",
        buttonCancel: "Cancelar",
        visibility: 'hidden',
        link: '/home',
        animationType: 'right'
    });
    @observable pageState = {};

    @action cleanFlash = () => {
        this.flashMessage = new FlashMessage({
            type: FlashMessageType.SUCCESS,
            title: "Sucesso!",
            message: "Operação efetuada com Sucesso",
            buttonLabel: "OK",
            buttonCancel: "Cancelar",
            visibility: 'hidden',
            link: '/agendamentos',
            animationType: 'right'
        });
    };

    @action cleanPageState = () => {
        this.pageState = {};
    };
}

export default new ConfigStore();


// WEBPACK FOOTER //
// ./src/stores/ConfigStore.js